<template>
	<Radar 
    		ref="chart"
    		:data="computedData"
    		:options="chartOptions"
    		:plugins="plugins"
    	/>
</template>

<script>
import { Radar } from 'vue-chartjs'
import { 
		Utils, 
		Chart, 
		ArcElement, 
		LineController, 
		LineElement, 
		BarController, 
		BarElement, 
		PieController, 
		RadarController, 
		PointElement, 
		LinearScale, 
		RadialLinearScale, 
		CategoryScale, 
		TimeSeriesScale, 
		Title, 
		Legend, 
		Filler, 
		Tooltip 
	} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
Chart.register(LineController, ArcElement, LineElement, BarController, BarElement, PieController, RadarController, PointElement, LinearScale, RadialLinearScale, CategoryScale, TimeSeriesScale, Title, Legend, Filler, Tooltip, ChartDataLabels);
import colorLib from '@kurkle/color';

export default {
	name: 'RadarChart',
	components: {
		Radar
	},
	props: {
		data: {
			type: Object,
			default: {}
		},
		options: {
			type: Object,
			default: {}
		},
		plugins: {
			type: Array,
			default: []
		},
		chartData: {
			type: Object,
			default: {
				options: {

				}
			}
		},
		tooltipDefaultConfig: Object,
		hasData: {
			type: Boolean,
			default: false
		},
		feTheme: {
			type: Object,
			default: {
				charts_no_data_text: 'No data'
			}
		}
	},
	data() {
		return {
			cdOptions: this.chartData.options,
		}
	},
	created() {
		const data = this.chartData.data
		data.datasets == null || data.datasets.length == 0 || data.datasets.map( el => {
					el.backgroundColor = this.transparentize(el.backgroundColor, .5)

					return el
				})
	},
	computed: {
		computedData() {
			return this.chartData.data
		},
		chartOptions() {
			const _this = this,
				cdOptions = this.cdOptions
			const scalesConfig = {
							r: {
								ticks: {
									stepSize: cdOptions.step_size_y,
									precision: 0,
								}
							}
						}
			return {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					// position: 'right',
				},
				plugins: {
					tooltip: {
						..._this.tooltipDefaultConfig
					},
					datalabels: {
						display: false,
					},
				},
				scales: scalesConfig
			}
		}
	},
	methods: {
		transparentize(value, opacity) {
			var alpha = opacity === undefined ? 0.5 : 1 - opacity;
			return colorLib(value).alpha(alpha).rgbString();
		}
	}
}
</script>